/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-filename-extension */
// @ts-nocheck
import React from 'react';
import { useTranslation } from 'react-i18next';
// material
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  useMediaQuery,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
// icons
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import ClearIcon from '@material-ui/icons/Clear';
// styles
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { fCurrency } from '../../../../utils/functions';
import styles from './styles';
// containers
import ButtonWithLoader from '../../../../commons/containers/ButtonWithLoader';
// components
import DatePicker from '../../../../commons/components/DatePicker';
import StyledTableCell from '../../../../commons/components/StyledTableCell';
// utils

const useStyles = makeStyles(styles);

function PurchaseForm(props) {
  const { t } = useTranslation();
  const classes = useStyles();

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const {
    serviceLines,
    supplyProductLines,
    controls,
    toggleForm,
    isOpen,
    edit,
    changeControls,
    invalidControls,
    suppliers,
    supplyProducts,
    clearEditLine,
    editLine,
    addServiceLine,
    warehouses,
    submit,
    vatPercentage,
  } = props;

  // total amount
  let total = 0;
  serviceLines.forEach((line) => {
    total += line.quantity * line.price;
  });

  supplyProductLines.forEach((line) => {
    total += line.quantity * line.price;
  });

  if (controls.iva) {
    total *= 1 + vatPercentage; // vatPercentage is a float with 0.xx value, by default is 0.19
  }

  total += Number(controls.additionalTaxes);
  total = Math.round((total + Number.EPSILON) * 100) / 100;

  return (
    <Dialog fullWidth onClose={toggleForm} maxWidth="md" open={isOpen} fullScreen={fullScreen}>
      <DialogTitle>{t(edit ? 'Edit acquisition or expense' : 'Create acquisition or expense')}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography gutterBottom variant="h6" component="h6">
              {t('General data')}
            </Typography>
          </Grid>
          <Grid item md={4} xs={6}>
            <DatePicker
              inputId="issueDate"
              label={t('Issue date')}
              type="date"
              fullWidth
              value={controls.issueDate}
              onChange={changeControls}
            />
          </Grid>
          <Grid item md={4} xs={6}>
            <DatePicker
              inputId="expirationDate"
              label={t('Expiration date')}
              type="date"
              fullWidth
              value={controls.expirationDate}
              onChange={changeControls}
            />
          </Grid>
          <Grid item md={4} xs={6}>
            <Autocomplete
              id="autocomplete-suppliers-filters-purchases"
              options={Object.values(suppliers).sort((a, b) =>
                a.entity().name.toLowerCase() > b.entity().name.toLowerCase() ? 1 : -1,
              )}
              getOptionLabel={(supplier) => supplier && supplier.entity().name}
              renderInput={(params) => (
                <TextField style={{ margin: 0 }} {...params} label={t('Supplier')} margin="normal" />
              )}
              onChange={(event, newValue) => {
                const e = {
                  autocomplete: true,
                  input: 'supplierId',
                  value: newValue ? newValue.id : '',
                };
                changeControls(e);
              }}
            />
            {props.invalidControls.supplierId && (
              <FormHelperText style={{ color: 'red' }}>{t('Supplier required')}</FormHelperText>
            )}
            {/* <FormControl fullWidth>
              <InputLabel id="supplier-label">Proveedor</InputLabel>
              <Select
                labelId="supplier-label"
                fullWidth
                value={controls.supplierId}
                onChange={changeControls}
                error={invalidControls.supplierId}
              >
                <MenuItem id="supplierId" value="" />
                {Object.values(suppliers).map((supplier) => (
                  <MenuItem
                    key={`supplier-form-option-${supplier.id}`}
                    id="supplierId"
                    value={supplier.id}
                  >
                    {supplier.entity().name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}
          </Grid>
          <Grid item md={4} xs={6}>
            <TextField
              fullWidth
              id="documentNumber"
              label={t('Document number')}
              type="number"
              value={controls.documentNumber}
              onChange={changeControls}
              error={invalidControls.documentNumber}
              helperText={invalidControls.documentNumber && t('Document number required')}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography gutterBottom variant="h6" component="h6">
              {t('Expenses')}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <FormControl component="fieldset">
              <RadioGroup
                row
                defaultValue="top"
                onChange={changeControls}
                value={controls.lineForm}>
                <FormControlLabel
                  value="supplyProduct"
                  control={<Radio color="primary" id="lineForm" />}
                  label={t('Supply')}
                  labelPlacement="end"
                />
                <FormControlLabel
                  value="service"
                  control={<Radio color="primary" id="lineForm" />}
                  label={t('Service')}
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          {controls.lineForm === 'service' ? (
            <Grid item md={3} xs={6}>
              <TextField
                fullWidth
                id="description"
                label={t('Description')}
                value={controls.description}
                onChange={changeControls}
                error={invalidControls.description}
                helperText={invalidControls.description && t('Description required')}
              />
            </Grid>
          ) : (
            <Grid item md={3} xs={6}>
              <Autocomplete
                value={
                  controls.supplyProductId &&
                  Object.values(supplyProducts).find((sp) => sp.id === controls.supplyProductId)
                }
                id="autocomplete-suppliesProduct-purchases"
                options={Object.values(supplyProducts).sort((a, b) =>
                  a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1,
                )}
                getOptionLabel={(supplyProduct) => supplyProduct && supplyProduct.name}
                renderInput={(params) => (
                  <TextField style={{ margin: 0 }} {...params} label={t('Supply')} margin="normal" />
                )}
                onChange={(event, newValue) => {
                  const e = {
                    autocomplete: true,
                    input: 'supplyProductId',
                    value: newValue ? newValue.id : '',
                  };
                  changeControls(e);
                }}
              />
              {/* <FormControl fullWidth>
                <InputLabel id="supplier-label">Insumo</InputLabel>
                <Select
                  labelId="supplier-label"
                  fullWidth
                  value={controls.supplyProductId}
                  onChange={changeControls}
                  error={invalidControls.supplyProductId}
                >
                  <MenuItem id="supplyProductId" value="">Ninguno</MenuItem>
                  {Object.values(supplyProducts).map((supplyProduct) => (
                    <MenuItem
                      key={`supply-product-form-option-${supplyProduct.id}`}
                      id="supplyProductId"
                      value={supplyProduct.id}
                    >
                      {supplyProduct.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl> */}
              {props.invalidControls.supplyProductId && (
                <FormHelperText style={{ color: 'red' }}>{t('Supply required')}</FormHelperText>
              )}
            </Grid>
          )}
          <Grid item md={2} xs={6}>
            <TextField
              fullWidth
              id="quantity"
              label={t('Quantity')}
              type="number"
              value={controls.quantity}
              onChange={changeControls}
              error={invalidControls.quantity}
              helperText={invalidControls.quantity && t('Invalid quantity error')}
            />
          </Grid>
          <Grid item md={3} xs={6}>
            <TextField
              fullWidth
              id="price"
              label={t('Price')}
              type="number"
              value={controls.price}
              onChange={changeControls}
              error={invalidControls.price}
              helperText={invalidControls.price && t('Invalid price error')}
            />
          </Grid>
          {controls.toEditServiceLineIndex !== '' ? (
            <>
              <Grid item md={2} xs={3}>
                <Button
                  fullWidth
                  size="small"
                  onClick={clearEditLine}
                  startIcon={<ClearIcon />}
                  variant="contained"
                  className={classes.filterButton}
                  color="primary">
                  {t('Clear')}
                </Button>
              </Grid>
              <Grid item md={2} xs={3}>
                <Button
                  fullWidth
                  size="small"
                  startIcon={<EditIcon />}
                  onClick={editLine}
                  variant="contained"
                  className={classes.filterButton}
                  color="primary">
                  {t('Edit')}
                </Button>
              </Grid>
            </>
          ) : (
            <Grid item md={3} xs={6}>
              <Button
                fullWidth
                size="small"
                startIcon={<AddIcon />}
                onClick={addServiceLine}
                variant="contained"
                className={classes.filterButton}
                color="primary">
                {t('Add')}
              </Button>
            </Grid>
          )}
          {controls.lineForm !== 'service' && (
            <Grid item md={3} xs={6}>
              <FormControl fullWidth>
                <InputLabel id="supplier-label">{t('Warehouse')}</InputLabel>
                <Select
                  labelId="supplier-label"
                  fullWidth
                  value={controls.warehouseId}
                  onChange={changeControls}
                  error={invalidControls.warehouseId}>
                  <MenuItem id="warehouseId" value="">
                    {t('None')}
                  </MenuItem>
                  {Object.values(warehouses)
                    .filter((warehouse) => warehouse.supplyWarehouse)
                    .map((warehouse) => (
                      <MenuItem
                        key={`warehouse-form-option-${warehouse.id}`}
                        id="warehouseId"
                        value={warehouse.id}>
                        {warehouse.name}
                      </MenuItem>
                    ))}
                </Select>
                {props.invalidControls.warehouseId && (
                  <FormHelperText style={{ color: 'red' }}>{t('Warehouse required')}</FormHelperText>
                )}
              </FormControl>
            </Grid>
          )}
          <Grid item xs={12}>
            <TableContainer component={Paper} className={classes.tableRoot}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>{t('Product/Service')}</StyledTableCell>
                    <StyledTableCell align="right">{t('Warehouse')}</StyledTableCell>
                    <StyledTableCell align="right">{t('Quantity')}</StyledTableCell>
                    <StyledTableCell align="right">{t('Price')}</StyledTableCell>
                    <StyledTableCell align="right">{t('Subtotal')}</StyledTableCell>
                    <StyledTableCell align="right" />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {serviceLines.map((row, index) => (
                    <TableRow key={`${row.description}-${index}`}>
                      <StyledTableCell component="th" scope="row">
                        {row.description}
                      </StyledTableCell>
                      <StyledTableCell align="right" />
                      <StyledTableCell align="right">{row.quantity}</StyledTableCell>
                      <StyledTableCell align="right">{fCurrency.format(row.price)}</StyledTableCell>
                      <StyledTableCell align="right">
                        {fCurrency.format(row.quantity * row.price)}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        <IconButton
                          data-index={index}
                          data-type="serviceLines"
                          onClick={props.setEditLine}>
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          data-index={index}
                          data-type="serviceLines"
                          onClick={props.deleteLine}>
                          <DeleteIcon />
                        </IconButton>
                      </StyledTableCell>
                    </TableRow>
                  ))}
                  {supplyProductLines.map((row, index) => (
                    <TableRow key={`${row.description}-${index}`}>
                      <StyledTableCell component="th" scope="row">
                        {supplyProducts[row.supplyProductId].name}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {warehouses[row.warehouseId].name}
                      </StyledTableCell>
                      <StyledTableCell align="right">{row.quantity}</StyledTableCell>
                      <StyledTableCell align="right">{fCurrency.format(row.price)}</StyledTableCell>
                      <StyledTableCell align="right">
                        {fCurrency.format(row.quantity * row.price)}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        <IconButton
                          data-index={index}
                          data-type="supplyProductLines"
                          onClick={props.setEditLine}>
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          data-index={index}
                          data-type="supplyProductLines"
                          onClick={props.deleteLine}>
                          <DeleteIcon />
                        </IconButton>
                      </StyledTableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item>
                <TextField
                  fullWidth
                  id="additionalTaxes"
                  label={t('Other taxes')}
                  type="number"
                  value={controls.additionalTaxes}
                  onChange={changeControls}
                  size="small"
                />
              </Grid>
              <Grid item>
                <FormControlLabel
                  control={<Checkbox id="iva" checked={controls.iva} onChange={changeControls} />}
                  label={t('VAT')}
                />
              </Grid>
              <Grid item>
                <div className={classes.totalLabel}>{t('Total amount', { amount: fCurrency.format(total) })}</div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={toggleForm} color="primary" variant="outlined">
          {t('CANCEL')}
        </Button>
        <ButtonWithLoader onClick={submit} autoFocus buttonId="create-edit-purchase">
          {t(edit ? 'Edit' : 'Create')}
        </ButtonWithLoader>
      </DialogActions>
    </Dialog>
  );
}

export default PurchaseForm;
